var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-btn',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.rfApp(_setup.extra.path, _setup.extra.params)}}},[_vm._v(_vm._s(_setup.v))])
}
var staticRenderFns = []

export { render, staticRenderFns }